import { secondAxios } from "../../../../../../api/axios";

export const getTimesheets = async (fabId) => {
  const response = await secondAxios.get("fab-timesheets/" + fabId);
  console.log("getTimesheets response", response);
  return response.data;
};

export const createTimesheet = async (userEmail, fabricationId, timesheet) => {
  const postRequestData = {
    ...timesheet,
    hours: parseInt(timesheet.hours) || 0,
    progress: parseInt(timesheet.progress) || 0,
    user: userEmail,
  };
  console.log("createTimesheet", fabricationId, timesheet, userEmail);
  await secondAxios.post(`fab-timesheets/${fabricationId}`, postRequestData);
};

export const updateTimesheet = async (timesheet) => {
  await secondAxios.put(`fab-timesheets/${timesheet.id}`, timesheet);
};

export const deleteTimesheet = async (timesheetId) => {
  await secondAxios.delete(`fab-timesheets/${timesheetId}`);
};
